// ImageKit CDN in front of the public GCS bucket — does on-the-fly format
// conversion (AVIF/WebP via `f-auto`) and resizing, and edge-caches the result.
// Original URLs stay in Firestore; we wrap at render time. Non-GCS URLs pass
// through untouched.

const IMAGEKIT_BASE = 'https://ik.imagekit.io/ambasada';
const GCS_PREFIX = 'https://storage.googleapis.com/advocacy-fab21.appspot.com/';

export function cdnImage(url, { width, quality = 80 } = {}) {
    if (!url || !url.startsWith(GCS_PREFIX)) return url;
    const [path, query] = url.slice(GCS_PREFIX.length).split('?');
    const transforms = ['f-auto', `q-${quality}`, width && `w-${width}`]
        .filter(Boolean)
        .join(',');
    const suffix = query ? `?${query}` : '';
    return `${IMAGEKIT_BASE}/tr:${transforms}/${path}${suffix}`;
}
